export default __webpack_public_path__ + "static/flossie-c88184ef87d441254053df17caf6e8e5.png";